<template>
    <div class="tjpopup" v-show="dataVal.flag" @click.stop="handleRefund">
        <div class="tj" @click.stop>
            <div class="tj_head">
                <div class="tj_head_title">{{ dataVal.title }}</div>
            </div>
            <div class="tj_body">{{ dataVal.content }} </div>
            <div class="tj_foot">
                <div class="tj_foot_btn" @click="handleRefund">取消</div>
                <div class="tj_foot_btn tj_foot_btn2" @click="handleSubmit">确定</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'validate',
    props: ['dataVal'],
    data() {
        return {
            value: ''
        }
    },
    methods: {
        //取消弹窗
        handleRefund() {
            let data = {
                flag: false,
                submitFlag: false
            }
            this.$emit("validateCal", data);
        },
        handleSubmit() {
            let obj = {
                flag: false,//弹窗是否显示
                submitFlag: true,//是否调用接口
            }
            this.$emit("validateCal", obj);
        },
    },
    watch: {
        dataVal: {
            handler(newVal, oldVal) {
                if (newVal.flag) {
                    if (newVal.type == 'edit') {
                        this.value = newVal.value
                    } else {
                        this.value = ''
                    }
                }
            },
            deep: true
        }
    }
}
</script>

<style scoped lang="scss">
.tjpopup {
    width: 100vw;
    height: 100vh;
    background-color: rgba($color: #000000, $alpha: 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9;

    .tj {
        background-color: #fff;
        border-radius: 16px;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        padding-bottom: 20px;

        .tj_head {
            width: 100%;
            height: 50px;
            background-color: #f6f6f6;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 0 20px;

            .tj_head_title {
                font-size: 16px;
                color: #333333;
                cursor: default;
            }
        }

        .tj_body {
            width: 100%;
            font-size: 14px;
            letter-spacing: 1px;
            color: #333333;
            display: flex;
            align-items: center;
            padding: 0 95px;
            margin-top: 30px;
        }

        .tj_foot {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0 40px;
            margin-top: 30px;

            .tj_foot_btn {
                width: 80px;
                height: 32px;
                font-size: 14px;
                color: #606266;
                background-color: #ffffff;
                border-radius: 4px;
                border: solid 1px #dbdbdb;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
            }

            .tj_foot_btn2 {
                color: #ffffff;
                background-color: #e64a19;
                border: solid 1px #e64a19;
            }
        }
    }
}
</style>